import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const useDocumentTitle = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const updateTitle = () => {
      document.title = t('documentTitle');
    };

    updateTitle();
    i18n.on('languageChanged', updateTitle);

    return () => {
      i18n.off('languageChanged', updateTitle);
    };
  }, [t, i18n]);
};

export default useDocumentTitle;
